import React from 'react';
import { Card, CardText, CardBody, CardLink,
  CardTitle, CardSubtitle, Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import * as routes from '../Constants/routes';

const ArticleCard = (props) => {

  var articleCardStyle = {
    maxWidth:320,
    minWidth:300,
    marginBottom: 10
  };

  var titleStyle = {
    fontFamily: "Audiowide, cursive",
    color: "cadetblue"
  }

  return (
    <React.Fragment>

    {(props.page === "home" || props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Summer Time Chillin</CardTitle>
            <CardSubtitle>Break + Monthly Tournaments</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/Summer.png"} className="img-fluid" id="summer" alt="summer" />
          <CardBody>
            <CardText>{"Summer is upon us, read what that means inside."}</CardText>
            <Link to={routes.ARTICLEBASE + "26"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "home" || props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Friday Night Blitz 8</CardTitle>
            <CardSubtitle>Tournament Recap</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/anton.jpg"} className="img-fluid" id="anton" alt="anton" />
          <CardBody>
            <CardText>{"Recap of the tournament and review of the new format!"}</CardText>
            <Link to={routes.ARTICLEBASE + "25"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "home" || props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Grimm Rank 1 Interview</CardTitle>
            <CardSubtitle>April 2018</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/death.jpg"} className="img-fluid" id="death" alt="death" />
          <CardBody>
            <CardText>{"Grimms thoughts on the meta, the grind and the deck he used!"}</CardText>
            <Link to={routes.ARTICLEBASE + "24"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Friday Night Blitz 7</CardTitle>
            <CardSubtitle>Tournament Recap</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/Zirell.jpg"} className="img-fluid" id="zirellFN7" alt="zirellFN7" />
          <CardBody>
            <CardText>{"Recap of the tournament and next weeks new format!"}</CardText>
            <Link to={routes.ARTICLEBASE + "23"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Pauper Tournament</CardTitle>
            <CardSubtitle>Super Nova Sunday: Pauper</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/Pauper.jpg"} className="img-fluid" id="pauper" alt="pauper" />
          <CardBody>
            <CardText>{"An overview of our next event, coming on Sunday, May 20th"}</CardText>
            <Link to={routes.ARTICLEBASE + "22"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Crypto Zombies!</CardTitle>
            <CardSubtitle>Blockchain Programming</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/CryptoZombie.jpg"} className="img-fluid" id="zombie" alt="zombie" />
          <CardBody>
            <CardText>{"An update on Psynight's latest adventures in the world of programming."}</CardText>
            <Link to={routes.ARTICLEBASE + "21"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Friday Night Blitz 6</CardTitle>
            <CardSubtitle>Tournament Recap</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/Caelia310x180.jpg"} className="img-fluid" id="caelia" alt="caelia" />
          <CardBody>
            <CardText>{"Recap of the tournament from Psynight's perspective, including decklists!"}</CardText>
            <Link to={routes.ARTICLEBASE + "20"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Super Nova Sunday 3</CardTitle>
            <CardSubtitle>Tournament Recap</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/ChaosReigns.jpg"} className="img-fluid" id="chaosreigns" alt="chaosreigns" />
          <CardBody>
            <CardText>{"Recap of the tournament from EverlastingEmus's perspective, including decklists!"}</CardText>
            <Link to={routes.ARTICLEBASE + "19"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Friday Night Blitz 5</CardTitle>
            <CardSubtitle>Tournament Recap</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/Clockmaker.jpg"} className="img-fluid" id="clock" alt="clock" />
          <CardBody>
            <CardText>{"Recap of the tournament from Psynight's perspective, including decklists!"}</CardText>
            <Link to={routes.ARTICLEBASE + "18"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Ugh Why Ads?</CardTitle>
            <CardSubtitle>Insight into the latest update.</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/ads.jpg"} className="img-fluid" id="ads" alt="ads" />
          <CardBody>
            <CardText>{"An explanation of why there are ads and a call for help!"}</CardText>
            <Link to={routes.ARTICLEBASE + "16"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Super Nova Sunday 2</CardTitle>
            <CardSubtitle>Tournament Recap</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/Zirell.jpg"} className="img-fluid" id="zirell" alt="zirell" />
          <CardBody>
            <CardText>{"Recap of the tournament from EverlastingEmus's perspective, including decklists!"}</CardText>
            <Link to={routes.ARTICLEBASE + "17"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Friday Night Blitz 4</CardTitle>
            <CardSubtitle>Tournament Recap</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/guide.jpg"} className="img-fluid" id="guide" alt="guide" />
          <CardBody>
            <CardText>{"Recap of the tournament from Psynight's perspective, including decklists!"}</CardText>
            <Link to={routes.ARTICLEBASE + "15"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Super Nova Sunday 1</CardTitle>
            <CardSubtitle>Tournament Recap</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/Frenzy310x180.jpg"} className="img-fluid" id="frenzy2" alt="frenzy2" />
          <CardBody>
            <CardText>{"Recap of the tournament from EverlastingEmus's perspective, including decklists!"}</CardText>
            <Link to={routes.ARTICLEBASE + "14"}>Read Now!</Link>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Rich Text Editor!</CardTitle>
            <CardSubtitle>Quill is now integrated.</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/quill.jpg"} className="img-fluid" id="quill" alt="quill" />
          <CardBody>
            <CardText>{"Deck descriptions now have a RTE!  Deckbuilding Instructions in the link below."}</CardText>
            <CardLink href="https://docs.google.com/document/d/1_hL6hSs85-IvJO9IvPGEJl9qOetlDDS0v82P3WpwLak/edit?usp=sharing" target="_blank" >Read Now!</CardLink> <Badge color="info">Google Doc Link</Badge>
          </CardBody>
        </Card>
    }

    {(props.page === "articles" && props.type === "hq") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>Friday Night Blitz 3</CardTitle>
            <CardSubtitle>Tournament Recap</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/Surprise.jpg"} className="img-fluid" id="surprise" alt="surprise" />
          <CardBody>
            <CardText>{"Recap of the tournament from Psynight's perspective, including decklists!"}</CardText>
            <Link to={routes.FRIDAY3}>Read Now!</Link>
          </CardBody>
        </Card>
    }

  {(props.page === "articles" && props.type === "links") &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Nova Token: Latest Developments</CardTitle>
          <CardSubtitle>Updated Roadmap for Nova Blitz</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/Roadmap.jpg"} className="img-fluid" id="roadmap" alt="roadmap" />
        <CardBody>
          <CardText>{"Nova Blitz and Nova Tokens are intertwined read about the latest developments."}</CardText>
          <CardLink href="https://medium.com/@novablitz/nova-token-latest-developments-489ddc1cd3d5">Read Now!</CardLink> <Badge color="info">Off Site Link</Badge>
        </CardBody>
      </Card>
  }

  {(props.page === "articles" && props.type === "hq") &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Friday Night Blitz 2</CardTitle>
          <CardSubtitle>Tournament Recap</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/Caelia310x180.jpg"} className="img-fluid" id="frenzy" alt="frenzy" />
        <CardBody>
          <CardText>{"Recap of the tournament from Psynight's perspective, including decklists!"}</CardText>
          <Link to={routes.FRIDAY2}>Read Now!</Link>
        </CardBody>
      </Card>
  }

  {(props.page === "articles" && props.type === "hq") &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Friday Night Blitz 1</CardTitle>
          <CardSubtitle>Tournament Recap</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/Frenzy310x180.jpg"} className="img-fluid" id="frenzy" alt="frenzy" />
        <CardBody>
          <CardText>{"Recap of the tournament from Psynight's perspective, including decklists!"}</CardText>
          <Link to={routes.FRIDAY1}>Read Now!</Link>
        </CardBody>
      </Card>
  }

  {(props.page === "articles" && props.type === "hq") &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Deck Spotlight</CardTitle>
          <CardSubtitle>Archon Bomb by ISLIDrake</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/Archon.jpg"} className="img-fluid" id="archon" alt="archon" />
        <CardBody>
          <CardText>{"A deep dive into the card choice and strategy of ISLIDrake's deck Archon Bomb!"}</CardText>
          <Link to={routes.ARCHONBOMB}>Read Now!</Link>
        </CardBody>
      </Card>
  }

  {(props.page === "articles" && props.type === "hq") &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Friday Night Blitz</CardTitle>
          <CardSubtitle>Tournaments hosted by Nova Blitz HQ</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/FridayBlitz.png"} className="img-fluid" id="FridayBlitz" alt="Friday Night Blitz" />
        <CardBody>
          <CardText>{"Read on for details of the new Friday Night Blitz tournaments hosted by Nova Blitz HQ."}</CardText>
          <Link to={routes.FRIDAYBLITZ}>Read Now!</Link>
        </CardBody>
      </Card>
  }

  {(props.page === "articles" && props.type === "hq") &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Bossryutsu Interview!</CardTitle>
          <CardSubtitle>February Rank 1 on the Leaderboard</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/BossFeb1-310x180.jpg"} className="img-fluid" id="Open" alt="Open" />
        <CardBody>
          <CardText>{"Read about Bossryutsu's thoughts on the game and how they made it to the top!"}</CardText>
          <Link to={routes.BOSSINTERVIEW}>Read Now!</Link>
        </CardBody>
      </Card>
  }

  {(props.page === "articles" && props.type === "hq") &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Deck Building Live!</CardTitle>
          <CardSubtitle>Major Update to the Site</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/deckofcards270x180.jpg"} className="img-fluid" id="Open" alt="Open" />
        <CardBody>
          <CardText>{"See whats new, and what's coming next!  Mostly importantly go add some decks!"}</CardText>
          <Link to={routes.DECKSLIVE}>Read Now!</Link>
        </CardBody>
      </Card>
  }

  {(props.page === "articles" && props.type === "hq") &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Nova Blitz HQ</CardTitle>
          <CardSubtitle>Welcome to the Site!</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/Open.jpg"} className="img-fluid" id="Open" alt="Open" />
        <CardBody>
          <CardText>{"A Nova Blitz community site dedicated to Nova Blitz News, Articles, Cards and Deck Building"}</CardText>
          <Link to={routes.OPEN}>Read Now!</Link>
        </CardBody>
      </Card>
  }

  {(props.page === "articles" && props.type === "hq") &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Grimm Interview</CardTitle>
          <CardSubtitle>January 2018 Rank 1 Player</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/Grimm1.jpg"} className="img-fluid" id="grimm1" alt="grimm1" />
        <CardBody>
          <CardText>{"Nova Blitz HQ's first interview.  Grimm is the first Rank 1 player of 2018.  Congratulations!"}</CardText>
          <Link to={routes.GRIMM}>Read Now!</Link>
        </CardBody>
      </Card>
    }

    {(props.page === "articles" && props.type === "links") &&
        <Card style={articleCardStyle}>
          <CardBody>
            <CardTitle style={titleStyle}>How it all Began</CardTitle>
            <CardSubtitle>A Brief History of Nova Blitz</CardSubtitle>
          </CardBody>
          <img src={"../ArticleImages/novahistory310.jpg"} className="img-fluid" id="novahistory" alt="novahistory" />
          <CardBody>
            <CardText>{"Head on over to Medium.com to read up on Nova Blitz's creation, from initial idea to kickstarter."}</CardText>
            <CardLink href="https://medium.com/@novablitz/a-brief-history-of-nova-blitz-8a3775ad2723">Read Now!</CardLink> <Badge color="info">Off Site Link</Badge>
          </CardBody>
        </Card>
    }

    {props.page === "articles" && props.type === "links" &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>The Five Aspects</CardTitle>
          <CardSubtitle>The Strengths and Weaknesses</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/5aspects310b.jpg"} className="img-fluid" id="5aspects" alt="5aspects" />
        <CardBody>
          <CardText>{"Arcane, Tech, Divine, Nature, and Chaos. Read about them on Medium.com"}</CardText>
          <CardLink href="https://medium.com/@novablitz/nova-blitz-the-five-aspects-4567c03c67c6">Read Now!</CardLink> <Badge color="info">Off Site Link</Badge>
        </CardBody>
      </Card>
    }

    {props.page === "articles" && props.type === "links" &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Matchmaking</CardTitle>
          <CardSubtitle>Read How Nova Blitz Approaches Matchmaking</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/matchmaking.jpg"} className="img-fluid" id="matchmaking" alt="matchmaking" />
        <CardBody>
          <CardText>{"Matchmaking is always a thorny subject for an online game. Read more on Medium.com."}</CardText>
          <CardLink href="https://medium.com/@novablitz/matchmaking-93737dd5e311">Read Now!</CardLink> <Badge color="info">Off Site Link</Badge>
        </CardBody>
      </Card>
    }

    {props.page === "articles" && props.type === "links" &&
      <Card style={articleCardStyle}>
        <CardBody>
          <CardTitle style={titleStyle}>Building the Economy</CardTitle>
          <CardSubtitle>A look at how Dragon Foundry approaches economy in Nova Blitz</CardSubtitle>
        </CardBody>
        <img src={"../ArticleImages/economy.jpg"} className="img-fluid" id="economy" alt="economy" />
        <CardBody>
          <CardText>{"How do developers decide how much a pack or draft should cost? Find out on Medium.com."}</CardText>
          <CardLink href="https://medium.com/@novablitz/building-the-economy-8c86fb32e918">Read Now!</CardLink> <Badge color="info">Off Site Link</Badge>
        </CardBody>
      </Card>
    }

    </React.Fragment>
  );
};

export default ArticleCard;



// WEBPACK FOOTER //
// ./src/Articles/ArticleCard.js